<template>
  <main-content-layout title="교육영상" img-src="lectures_collection_icon.png">
    <template v-slot:content>
      <v-row
        class="lectures-collection-layout"
        align="stretch"
        dense
        justify="start"
      >
        <v-col
          cols="6"
          v-for="title in lecturesTitleList"
          :key="title"
        >
          <v-card class="lectures-collection-content" rounded="lg" @click="routerLectures">
            <div class="lectures-header">
              <span><strong>{{ title }}</strong></span>
            </div>
            <div class="lectures-bottom">
              <v-img class="router-icon" :src="require(`@/assets/images/icons/page_router_icon.png`)" />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </main-content-layout>
</template>

<script>

import MainContentLayout from "@/pages/Main/components/layout/MainContentLayout.vue";
import router from "@/router";

export default {
  name: "LecturesCollection",
  components: {MainContentLayout},
  data() {
    return {
      lecturesTitleList: ["법인필수의무교육", "담보대출교육", "전세대출교육", "기타대출교육"]
    }
  },
  methods: {
    routerLectures() {
      router.push({name: "LectureList"});
    }
  }
}
</script>

<style lang="scss" scoped>
.lectures-collection-layout {
  width: 100%;
  height: 100%;
  .lectures-collection-content {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 16px;
    height: 100%;
    max-height: 200px;
    .lectures-header {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      font-size: min(3.5vw, 20px);
      text-wrap: nowrap;
    }
    .lectures-bottom {
      position: absolute;
      right: 10px;
      bottom: 10px;
      .router-icon {
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
        border-radius: 40px;
      }
    }
  }
}
</style>